var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentRow.length > 0)?_c('div',[_c('div',{staticClass:"row comp_row"},_vm._l((_vm.componentRow),function(componentName){return _c('div',{staticClass:"col-12"},[_c('component-logic',{attrs:{"program-guide":_vm.programGuide,"component-name":componentName}})],1)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c24e454a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard/components/ComponentRow.vue
// module id = null
// module chunks = 